// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3iQRb","Loans":"App_Loans__2_hlO","anchor":"App_anchor__342KB","Calc":"App_Calc__3igiE","mover":"App_mover__qiue3","messengers":"App_messengers__3cauq"};